import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-entity-id", "data-index"]

import { computed, ref } from "vue";
import QTLiteRowCells from "./QTLiteRowCells.vue";
import { useRowParameterHeights } from "../composables/useRowParameterHeights";
import type { LiteColumn, LiteRow } from "../types";


export default /*@__PURE__*/_defineComponent({
  __name: 'QTLiteRow',
  props: {
    row: {},
    columns: {},
    srcElement: {},
    WA: { type: Boolean },
    isChecked: { type: Boolean },
    rowIndex: {},
    rowNumberBase: {},
    widthStamp: {},
    dataIndex: {}
  },
  emits: ["toggleCheckbox", "changeHoverRecord", "changeHeights", "refreshNeeded", "updatePerson", "updateSelection", "checkBoxClick", "sourceItemsRequested"],
  setup(__props: any, { expose: __expose }) {

const props = __props;



const trEl = ref<HTMLTableRowElement | null>(null);
const widthsFingerprint = computed(() => `${props.columns.map((c) => c.id).join("|")}::${props.widthStamp || ""}`);
const alignmentEnabled = computed<boolean>(() => !!props.row.hasParameterAlignment);
useRowParameterHeights({ rowEl: trEl, enabled: alignmentEnabled, trigger: widthsFingerprint });

// корневой <tr> нужен QTLiteBody, чтобы отдать строку виртуализатору на замер высоты
__expose({ get rootEl() { return trEl.value; } });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", {
    ref_key: "trEl",
    ref: trEl,
    class: _normalizeClass(["qtl-row", { 'qtl-row--checked': _ctx.isChecked, 'qtl-row--even': _ctx.rowIndex % 2 === 1 }]),
    "data-entity-id": _ctx.row.entityId,
    "data-index": _ctx.dataIndex
  }, [
    _createVNode(QTLiteRowCells, {
      row: _ctx.row,
      "row-index": _ctx.rowIndex,
      "row-number-base": _ctx.rowNumberBase,
      columns: _ctx.columns,
      "src-element": _ctx.srcElement,
      WA: _ctx.WA,
      "is-checked": _ctx.isChecked,
      onToggleCheckbox: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleCheckbox', $event))),
      onChangeHoverRecord: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeHoverRecord', $event))),
      onChangeHeights: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('changeHeights', $event))),
      onRefreshNeeded: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('refreshNeeded'))),
      onUpdatePerson: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('updatePerson', $event))),
      onUpdateSelection: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('updateSelection', $event))),
      onCheckBoxClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('checkBoxClick'))),
      onSourceItemsRequested: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('sourceItemsRequested', $event)))
    }, null, 8, ["row", "row-index", "row-number-base", "columns", "src-element", "WA", "is-checked"])
  ], 10, _hoisted_1))
}
}

})